import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from '@/components/Navbar';
import AnnouncementBar from '@/components/AnnouncementBar';
import Footer from '@/components/Footer';
import ChatWidget from '@/components/ChatWidget';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Benefits from '@/pages/Benefits';
import About from '@/pages/About';
import FAQ from '@/pages/FAQ';
import Contact from '@/pages/Contact';
import Checkout from '@/pages/Checkout';
import OrderConfirmation from '@/pages/OrderConfirmation';
import PaymentSuccess from '@/pages/PaymentSuccess';
import Returns from '@/pages/Returns';
import TrackOrder from '@/pages/TrackOrder';
import Subscribe from '@/pages/Subscribe';
import SubscriptionSuccess from '@/pages/SubscriptionSuccess';
import AdminOrders from '@/pages/AdminOrders';
import AdminLogin from '@/pages/AdminLogin';
import AdminResetPassword from '@/pages/AdminResetPassword';
import AdminProtectedRoute from '@/components/AdminProtectedRoute';
import ScrollToTop from '@/components/ScrollToTop';
import { AuthProvider } from '@/context/AuthContext';
import { CustomerAuthProvider } from '@/context/CustomerAuthContext';
import { CartProvider } from '@/context/CartContext';
import CustomerAuth from '@/pages/CustomerAuth';
import CustomerResetPassword from '@/pages/CustomerResetPassword';
import VerifyEmail from '@/pages/VerifyEmail';
import AuthCallback from '@/pages/AuthCallback';
import Account from '@/pages/Account';
import Cart from '@/pages/Cart';
import BumperOffer from '@/pages/BumperOffer';
import CurcuminVsTurmeric from '@/pages/CurcuminVsTurmeric';
import BestCurcuminSupplementUK from '@/pages/BestCurcuminSupplementUK';
import MissGoaEvent from '@/pages/MissGoaEvent';
import MedicalHerbalistConsultation from '@/pages/MedicalHerbalistConsultation';
import NorthamptonWellness from '@/pages/NorthamptonWellness';
import BCM95Explained from '@/pages/BCM95Explained';
import WhyIIYPhytoventra from '@/pages/WhyIIYPhytoventra';
import BiocurcumaxGuide from '@/pages/BiocurcumaxGuide';
import SominOn from '@/pages/SominOn';
import DiscoveryCall from '@/pages/DiscoveryCall';
import LycaRadioInterview from '@/pages/LycaRadioInterview';import RangeProduct from '@/pages/RangeProduct';
import PractitionerPortal from '@/pages/PractitionerPortal';
import PractitionerResetPassword from '@/pages/PractitionerResetPassword';
import JointHealthSupplementsUK from '@/pages/JointHealthSupplementsUK';
import TurmericSupplementsUK from '@/pages/TurmericSupplementsUK';
import TurmericWithoutBlackPepper from '@/pages/TurmericWithoutBlackPepper';
import VeganTurmericSupplementUK from '@/pages/VeganTurmericSupplementUK';
import HowToChooseTurmericSupplement from '@/pages/HowToChooseTurmericSupplement';
import TurmericCurcuminBenefitsUK from '@/pages/TurmericCurcuminBenefitsUK';
import ProductSlugRedirect from '@/pages/ProductSlugRedirect';
import BumperOfferPopup from '@/components/BumperOfferPopup';
import BumperOfferReclaimPill from '@/components/BumperOfferReclaimPill';
import Analytics from '@/components/Analytics';
import ClarityLoader from '@/components/ClarityLoader';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Analytics />
            <ClarityLoader />
            <div className="App">
              <AnnouncementBar />
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/benefits" element={<Benefits />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/bumper-offer" element={<BumperOffer />} />
                <Route path="/curcumin-vs-turmeric" element={<CurcuminVsTurmeric />} />
                <Route path="/best-curcumin-supplement-uk" element={<BestCurcuminSupplementUK />} />
                <Route path="/miss-goa-international" element={<MissGoaEvent />} />
                <Route path="/medical-herbalist-consultation" element={<MedicalHerbalistConsultation />} />
                <Route path="/northampton-wellness" element={<NorthamptonWellness />} />
                <Route path="/bcm-95-explained" element={<BCM95Explained />} />
                <Route path="/why-iiy-phytoventra" element={<WhyIIYPhytoventra />} />
                <Route path="/biocurcumax" element={<BiocurcumaxGuide />} />
                <Route path="/somin-on" element={<SominOn />} />
                <Route path="/discovery-call" element={<DiscoveryCall />} />
                <Route path="/lyca-radio-interview" element={<LycaRadioInterview />} />
                <Route path="/tri-low" element={<RangeProduct />} />
                <Route path="/gluzo-eaze" element={<RangeProduct />} />
                <Route path="/livslim-xl" element={<RangeProduct />} />
                <Route path="/enercalm" element={<RangeProduct />} />
                <Route path="/practitioner" element={<PractitionerPortal />} />
                <Route path="/practitioner/reset-password" element={<PractitionerResetPassword />} />
                <Route path="/joint-health-supplements-uk" element={<JointHealthSupplementsUK />} />
                <Route path="/turmeric-curcumin-benefits-uk" element={<TurmericCurcuminBenefitsUK />} />
                <Route path="/turmeric-supplements-uk" element={<TurmericSupplementsUK />} />
                <Route path="/turmeric-without-black-pepper" element={<TurmericWithoutBlackPepper />} />
                <Route path="/vegan-turmeric-supplement-uk" element={<VeganTurmericSupplementUK />} />
                <Route path="/how-to-choose-a-turmeric-supplement" element={<HowToChooseTurmericSupplement />} />
                {/* High-intent search-query slug aliases → product page (noindex, UTM-tagged) */}
                <Route path="/buy-bcm-95-uk" element={<ProductSlugRedirect utmCampaign="buy-bcm-95-uk" />} />
                <Route path="/buy-biocurcumax" element={<ProductSlugRedirect utmCampaign="buy-biocurcumax" />} />
                <Route path="/bcm-95-uk" element={<ProductSlugRedirect utmCampaign="bcm-95-uk" />} />
                <Route path="/biocurcumax-uk" element={<ProductSlugRedirect utmCampaign="biocurcumax-uk" />} />
                <Route path="/products/bcm-95-bio-curcumin" element={<ProductSlugRedirect utmCampaign="bcm-95-bio-curcumin-slug" />} />
                {/* Social-channel short URLs (paste these in social bios; each carries a distinct UTM for GA4 attribution) */}
                <Route path="/ig" element={<ProductSlugRedirect utmCampaign="instagram-bio" />} />
                <Route path="/fb" element={<ProductSlugRedirect utmCampaign="facebook-bio" />} />
                <Route path="/x" element={<ProductSlugRedirect utmCampaign="x-bio" />} />
                <Route path="/linkedin" element={<ProductSlugRedirect utmCampaign="linkedin-bio" />} />
                <Route path="/yt" element={<ProductSlugRedirect utmCampaign="youtube-bio" />} />
                <Route path="/tt" element={<ProductSlugRedirect utmCampaign="tiktok-bio" />} />
                <Route path="/order-confirmation" element={<OrderConfirmation />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/returns" element={<Returns />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/subscribe" element={<Subscribe />} />
                <Route path="/subscription-success" element={<SubscriptionSuccess />} />
                <Route path="/login" element={<CustomerAuth mode="login" />} />
                <Route path="/signup" element={<CustomerAuth mode="signup" />} />
                <Route path="/reset-password" element={<CustomerResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/reset-password" element={<AdminResetPassword />} />
                <Route
                  path="/admin/orders"
                  element={
                    <AdminProtectedRoute>
                      <AdminOrders />
                    </AdminProtectedRoute>
                  }
                />
              </Routes>
              <Footer />
              <ChatWidget />
              <Toaster position="top-right" richColors />
              {/* Bumper offer popup + reclaim pill removed per client request (2026) */}
            </div>
          </BrowserRouter>
        </CartProvider>
      </CustomerAuthProvider>
    </AuthProvider>
  );
}

export default App;
